export function speechUtteranceChunker(e, t, n) {
    var c,
        s = (t = t || {}) && void 0 !== t.offset ? e.text.substring(t.offset) : e.text;
    if (e.voice && 'native' === e.voice.voiceURI) {
        c = e;
        c.text = s;
        c.addEventListener('end', function () {
            if (speechUtteranceChunker.cancel) {
                (speechUtteranceChunker.cancel = !1);
            }
            void 0 !== n && n();

        });
    }
    else {
        var r = (t && t.chunkLength) || 160,
            i = new RegExp(
                '^[\\s\\S]{' +
                Math.floor(r / 2) +
                ',' +
                r +
                '}[.!?,]{1}|^[\\s\\S]{1,' +
                r +
                '}$|^[\\s\\S]{1,' +
                r +
                '} '
            ),
            o = s.match(i);
        o = o != null ? o : "";

        if (o != null && (void 0 === o[0] || o[0].length <= 2)) return void (void 0 !== n && n());
        var a,
            h = o[0];
        for (a in ((c = new SpeechSynthesisUtterance(h)), e))
            e.hasOwnProperty(a) && 'text' !== a && (c[a] = e[a]);
        c.addEventListener('end', function () {
            if (speechUtteranceChunker.cancel) {
                (speechUtteranceChunker.cancel = !1)
            } else {
                (t.offset = t.offset || 0);
                (t.offset += h.length - 1);
                speechUtteranceChunker(e, t, n);
            }



        });
    }
    if (t.modifier) {
        t.modifier(c);
    }
    //console.log(c);

    setTimeout(function () {
        for (
            var e = window.speechSynthesis.getVoices(), t = document.documentElement.lang, n = 0;
            n < e.length;
            n++
        )
            if (e[n].lang.substring(0, 2) === t.substring(0, 2)) {
                c.voice = e[n];
                break;
            }
        speechSynthesis.speak(c);
    }, 0);

}
